import request from '@/utils/request'

export function getDiagnosisSummaryList(params) {
  return request({
    url: '/api/diagnosisSummaryList',
    method: 'get',
    params,
  })
}
